import { createContext, useContext, useState } from "react";

const ModuleAccessNavContext = createContext({
  navItems: [],
  setNavItems: () => {},
  accessCodeMap: {},
  setAccessCodeMap: () => {},
});

export const ModuleAccessNavProvider = ({ children }) => {
  const [navItems, setNavItems] = useState([]);
  const [accessCodeMap, setAccessCodeMap] = useState();

  return (
    <ModuleAccessNavContext.Provider
      value={{
        navItems,
        accessCodeMap,
        setAccessCodeMap,
        setNavItems,
      }}
    >
      <>{children}</>
    </ModuleAccessNavContext.Provider>
  );
};

export const useModuleAccessNavContext = () => {
  const context = useContext(ModuleAccessNavContext);
  if (!context) {
    throw new Error(
      "useModuleAccessNavContext must be used within a ModuleAccessNavProvider"
    );
  }
  return context;
};
